import { gql } from '@apollo/client';
import { itemsFragment } from '../fragments/items';
import { graphql } from '../../graphql';

export const searchTotalCountQuery = graphql(`
  query SearchTotalCount($filter: ItemFilter) {
    itemsConnection(filter: $filter) {
      totalCount
    }
  }
`);

export const searchItemsQuery = gql`
  query SearchItems(
    $first: Int
    $filter: ItemFilter
    $sort: ItemConnectionSort!
    $cursor: String
  ) {
    itemsConnection(
      first: $first
      after: $cursor
      filter: $filter
      sort: $sort
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const similarItemsQuery = gql`
  query SimilarItems($first: Int, $filter: ItemFilter, $cursor: String) {
    itemsConnection(first: $first, after: $cursor, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;

export const embedItemsQuery = gql`
  query EmbedItems(
    $first: Int
    $filter: ItemFilter
    $sort: ItemConnectionSort!
  ) {
    itemsConnection(first: $first, filter: $filter, sort: $sort) {
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;
